import { makeStyles, Theme } from '@material-ui/core/styles';
import { OrderStatus } from '@src/pages/Deliveries/context/orders';

const styles = makeStyles(({ spacing, palette, typography,variables }: Theme) => ({
  root: {
    textTransform: 'none',
    boxShadow: 'none',
  },
  informationBadges: {
    color: '#fff',
    width:'114px',
    '&:nth-child(2)': {
      '& .badge-flag': {
        borderRadius: '0px 0px 4px 4px',
        marginTop: '1px',
        '& span': {
          paddingLeft: '0',
        },
      },
    },
    '& .badge-flag': {
      color: palette.jet?.containerDefault,
      display: 'flex',
      padding: `${variables?.spacingNone} ${variables?.spacingA}`,
      borderRadius: '4px 4px 0px 0px',
      whiteSpace: 'normal',
      minHeight: '24px',
      height: 'auto',
      textAlign: 'center',
      '& span': {
        textOverflow: 'inherit !important',
        whiteSpace: 'normal',
        padding: '0 3px',
      },
      '&.single': {
        borderRadius: '4px !important',
      },
      '& img': {
        width: '24px',
        height: '24px',
        padding: '4px',
        transform: 'inherit',
        margin: '0',
      },

      [`&.status-${OrderStatus.Delivered}`]: {
        backgroundColor: palette.jet?.supportPositiveInverse,
      },
      [`&.status-${OrderStatus.InDelivery}`]: {
        backgroundColor: palette.jet?.supportInfo,
      },
      [`&.status-${OrderStatus.Assigned}`]: {
        backgroundColor: palette.jet?.contentBrand,
      },
      [`&.status-${OrderStatus.AssignedToNextPool}`]: {
        backgroundColor: palette.jet?.contentBrand,
      },
      [`&.status-${OrderStatus.AssignedToNextPool}`]: {
        backgroundColor: palette.secondary.main,
      },
      [`&.status-${OrderStatus.Unassigned}`]: {
        backgroundColor: palette.jet?.contentError,
      },
    },
  },
}));

export default styles;
